"use client"
import { Button } from '@douyinfe/semi-ui'
import { useLogin, useUserInfo } from '@/hooks/useUser'
import Link from 'next/link'
import { useModal } from "../modal/Provdier"
import { IData } from '@/types'

export default function EduHeader({ children, data }: { children?: React.ReactNode, data?: IData }) {
  const { setIsLoginOpen, setIsRegisterOpen } = useModal()
  const [userInfo] = useUserInfo()
  const { logout } = useLogin()

  return <div className="flex justify-between items-center">

    {/* <div className="flex items-center justify-between gap-x-6">
      <div className="flex items-center">
        <img src="/images/logo.png" alt="logo" className="w-6 h-6 mr-1" />
        <span className="underline text-[15px] text-[#303133]">探月学校</span>
      </div>
    </div> */}
    {children}

    <div className="flex items-center justify-between gap-x-2 ml-auto">
      {
        data?.id === 'publish' ? <Link href="https://agent.wenkoo.com.cn" target="_blank" className="px-3 h-10 bg-white hover:bg-white/10 shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] rounded-xl flex items-center justify-center cursor-pointer">
          <span className="text-[15px] text-[#303133]">智能体后台</span>
        </Link> : ''
      }

      <Link href="/chat" className="w-[82px] h-10 bg-white hover:bg-white/10  shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] rounded-[20px] flex items-center cursor-pointer justify-left pl-2.5 hidden lg:flex">
        <span className="font_family icon-Review text-2xl! text-[#303133] mr-1"></span>
        <span className="text-[15px] text-[#303133]">对话</span>
      </Link>

      {/* <div className="w-[82px] h-10 bg-white hover:bg-white/10 shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] rounded-[20px] flex items-center justify-center cursor-pointer">
        <span className="font_family icon-Image text-2xl! text-[#303133] mr-1"></span>
        <span className="text-[15px] text-[#303133]">生图</span>
      </div> */}
      {/* <div className="w-[82px] h-10 bg-white hover:bg-white/10 shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] rounded-[20px] flex items-center justify-center cursor-pointer">
        <span className="font_family icon-Review text-2xl! text-[#303133] mr-1"></span>
        <span className="text-[15px] text-[#303133]">PPT</span>
      </div> */}

      {/* <div className="px-2 h-10 bg-white hover:bg-white/10 shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] rounded-xl flex items-center justify-center cursor-pointer">
        <span className="font_family icon-Translate text-2xl! text-[#303133]"></span>
      </div> */}



      {
        userInfo?.id ? (
          <div className='group relative'>
            <div onClick={logout} className="px-2 h-10 bg-white hover:bg-white/10 shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] rounded-xl flex items-center justify-center cursor-pointer">
              <span className="font_family icon-a-Home2 text-2xl! text-[#303133]"></span>
            </div>
            <div className="hidden group-hover:block absolute right-0 z-[1] pt-[10px] bg-white">
              <div className="w-[200px] shadow-[0_2px_6px_0_rgba(0,0,0,0.1)] rounded-lg flex flex-col">
                <div className="bg-[#F0F7FF] px-[10px] py-3">
                  <div className="text-[#303133] flex min-h-6">
                    {data?.name}用户
                  </div>

                  <div className="text-[#303133] flex text-xs h-6 w-full items-center">
                    {userInfo.phone}
                  </div>
                </div>
                <div className="flex flex-col justify-between p-[10px] h-full">
                  <Button
                    className="bg-[#F5F7FA] hover:bg-[#F5F7FA] border-none text-[13px]  mb-2 text-left"
                    onClick={logout}
                  >
                    <span className="text-[#303133]">退出登录</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>

        ) : (
          <>
            <div onClick={() => setIsRegisterOpen(true)} className="px-4 h-10 rounded-[12px] bg-white hover:bg-white/10 shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] items-center justify-center cursor-pointer hidden lg:flex">
              <span className="text-[15px] text-[#303133] font-bold">注册</span>
            </div>
            <div onClick={() => setIsLoginOpen(true)} className="px-4 h-10 bg-[#131921] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] rounded-[12px] items-center justify-center cursor-pointer flex">
              <span className="text-[15px] text-white font-bold">登录</span>
            </div>
          </>
        )
      }
    </div>
  </div>
}
